
import React, { useState, useRef, useEffect } from "react";
import enrichStyles from "./enrich-product.scss";
import styles from "../add-edit-product/add-edit-product.scss";
import flagStyles from "../add-edit-product/countrySlider/country-flags.scss";
import SliderHeader from "jd-library/SliderHeader";
import historyHandler from "jd-library/historyHandler";
import { useHistory, useLocation } from "react-router-dom";
import { connect, useDispatch } from "react-redux";
import {
  updateEditProductDetail,
  saveEnrichEditPorduct,
  discardAddProductMedia,
  resetProductData,
  hideProductEditSlider,
  getBizList,
  updateBizList,
  updateProductMedia,
  deleteProductImage,
  deleteProductVideo,
  toggleBiz,
  updateProductStatus,
  getListingData,
  setAuditObject,
  restoreProductData,
  setTabStatus,
  fetchCountryCode,
  showItemSearchSlider,
  setBrandSuggestion,
  setHybridData,
  updateProductsWithSmartFill,
  getAuditProductUpdateLog,
  addRemoveSpecVariant,
  setShouldRetainScroll,
  addUpdateFixedSpecs
} from "../../actions/products";
import toastMessageActions from "jd-library/toastMessageActions";
import InputWithMovingLabel from 'jd-library/InputWithMovingLabel';
import ViewImage from "../../common/ViewImage/ViewImage";
import Button from "../../common/Button/Button";
import {
  fetchEnrichUrl,
  getMatchedUOM,
  skipEnrichProduct,
  identifyAuditFlow,
  formatProdDesc,
  setRouteChangeMessage,
  isValidURL
} from "../../utills";
import CSSTransition from "../../common/transition/Animation";
import ProductSpecification from "../add-edit-product/ProductSpecification";
import VideoListing from "../listing/VideoListing";
import UploadOptions from "../../common/upload-options/UploadOptions";
import LinkUploadSlider from "../../common/link-upload-slider/LinkUploadSlider";
import { toggleLibrarySlider } from "../../actions/videoLibrary";
import FormElement from "../add-edit-product/FormElement";
import SwipeableDrawer from "jd-library/SwipeableDrawer";
import ViewImageSlider from "../../common/ViewImage/ViewImageSlider";
import SliderWrapper from "jd-library/SliderWrapper";
import axios from "axios";
const actualProductWeightRegex = /^\d{0,10}(\.\d{0,3})?$/;
const productDimensions = {
  inputField: /^\d{0,10}(\.\d{0,2})?$/,
};
export const otherThanEnglish = /[^\x00-\x7F]/g;
import useOnScroll from "jd-library/useOnScroll";
import { getContent } from "jd-library/Clipboard";
import {
  fetchSpecificationAttributes,
  resetSpecificationFormData,
  resetSpecErrors
} from "../../actions/productSpecification";
import ManufacturerDetails from "../add-edit-product/c-specification-slider/components/manufacturerDetails/index";
import ImporterDetails from "../add-edit-product/c-specification-slider/components/importerDetails/index";
import {
  updateBrandManufactureDetails,
  updateSpecificationData,
  resetBrandManufactureData,
} from "../../actions/productSpecification";
import {
  resetVariantData,
  validateVariants,
  setVariantProductData,
  setVariantData
} from "../../actions/variants";
import ComplianceFieldModal from "../add-edit-product/c-specification-slider/components/complianceFieldsModal/ComplianceFieldModal";
import CopyImagesSlider from "../../common/UploadOptions/CopyImages/CopyImagesSlider";
import { pageLoad, pageLoadForIos } from "../../common/Utills";
import DisputeImages from "../order/order-return/raise-return-claim/disputeImagesFlow/DisputeImages";
import ImageZoom from "../add-edit-product/image-zoom/ImageZoom";
import PackagingLabel from "../add-edit-product/c-specification-slider/components/packagingLabel/PackagingLabel";
import ProductBankIdCopy from "../../common/ProductBankIdCopy";

const allowedContractors = ["CONTRACTORV4"];

const EnrichEditProduct = (props) => {
  const dispatch = useDispatch();
  const productData = props.productData;
  let history = useHistory();

  let enrichHomePath = "/contractor-home";
  if (typeof window !== "undefined" && window.top != window.self) {
    enrichHomePath += "?loadedInIframe=true";
  }
  if (productData.error) {
    alert("No product data found for product bank id: "+productData.productId);
    history.push(enrichHomePath);
    return null;
  }
  const [productDescriptionEdited,setProductDescriptionEdited]=useState(false)
  const isTemplate = productData.isTemplate;
  const isIPhone = props.deviceData.isIphone || props.isJdSourceIOS;
  let selectTypeQuery = identifyAuditFlow({ query: true });
  const isAddProduct = productData.productId == "ADD_PRODUCT" || selectTypeQuery.isTemp;
  const fromSellerRejected = selectTypeQuery.fromSellerRejected === "true";
  const fromPhotos = selectTypeQuery.fromPhotos;
  const isProductOnlyProfile = props.session?.newProfile;
  const showUOMFields = productData.contentPerPiece && productData.unitPerPiece; //(productData.minOrderQuantity && productData.unitOfMeasurement) ||
  const [errors, updateError] = useState({
    name: "",
  });
  const savedUOM = useRef(props.unitOfMeasurement);


  const labelFrontImages = productData.labelFrontImageUrl ? productData.labelFrontImageUrl : [];
  const [labelFront, setFrontImage] = useState(labelFrontImages?.length ? labelFrontImages.map(cur => ({
    loading: false,
    key: '',
    url: cur,
    finalUrl: cur
  })) : []);

  const labelImages =productData.labelImageUrl ? productData.labelImageUrl : [];
  const [proofImages, setProofImagesList] = useState(labelImages?.length ? labelImages.map(cur => ({
    loading: false,
    key: '',
    url: cur,
    finalUrl: cur
  })) : []);
  const [isUploading,updateUploading] = useState(false);
  const [fieldsSet, updateStatus] = useState(false);
  const [scrollEl, setScrollEl] = useState(null);
  const [moreFieldsShown, updateMoreFields] = useState(() => {
    if (showUOMFields) {
      return true;
    }
    const attributes = productData.attributes || [];
    for (let i = 0; i < attributes.length; i++) {
      if (attributes[i].values && attributes[i].values.length) {
        return true;
      }
    }
    const customAttrs = productData.customAttrs;
    if (!customAttrs || !customAttrs.length) {
      return false;
    }

    return !!(customAttrs[0].name && customAttrs[0].value);
  });
  const isOwner =
    props.session.user.loggedUser &&
    props.session.user.loggedUser.userType == "OWNER"
      ? true
      : false;
  const flowCheck = identifyAuditFlow({ checkType: true });
  if (flowCheck.fetchNextAudit) {
    isAuditUrl = true;
  }
  if (flowCheck.searchAudit) {
    auditFromPage = true;
  }
  const isBrandedProduct =
    productData && productData.isBrandedProd ? true : false;

  let type = productData.queueType;
  if (productData.isObjectionable) {
    isObjectionableQueue = true;
  }
  const [enrichProdLoader, updateProdLoader] = useState(false);
  const [showBtnLoader, toggleBtnLoader] = useState(false);
  const [skipDrawer, updateSkipDrawer] = useState("");
  const [imageSliderVisible, updateViewImageSlider] = useState(null);
  const scrollRef = useRef(null);
  const [isScrolled, setScroll] = useState(false);
  const [showPaste, togglePaste] = useState(
    productData.description ? false : true
  );
  const [docReqModal, toggledocReqModal] = useState({ show: false });
  const [selectedCountry, updateSelectedCountry] = useState({
    ...productData.compliance?.country_of_origin,
  });
  const [showSellOnline, toggleSellOnline] = useState(productData.isSellOnline);
  const [isVariant, updateType] = useState(
    props.variantProps.variantProductData?.length ? 1 : 0
  );
  const [variantInfo, toggleVariantWelcome] = useState(false);
  let productOrService = props.selectedCategoryType;
  if (productData.categoryType) {
    productOrService = productData.categoryType.toLowerCase();
  } else if (selectTypeQuery.selectedProductType) {
    productOrService = selectTypeQuery.selectedProductType;
  } else if (selectTypeQuery.isTemp) {
    productOrService = "product";
  }

  const [backClick,setBackClick] = useState(false);
  const [selectedType, setSelectedType] = useState(productOrService);
  const dontResetEditProduct = useRef(false);
  const [showComplianceModal,updateShowComplianceModal] = useState(false);
  const [complianceModalShown,setComplianceModalShown] = useState(false);
  const scrollEle = useRef([]);
  let moreFieldsRef = useRef(null);
  let saveButtonStatus = useRef(null);
  let copytext = useRef(null);
  let copyProductBankIdText = useRef(null);
  let copyProductNameText = useRef(null);

  let imageArray = props.productData.imageUrlArr
    ? props.productData.imageUrlArr
    : [];
  let videoArray = props.productData.videoUrlArr
    ? props.productData.videoUrlArr
    : [];
  const mediaUrlArr = [...imageArray, ...videoArray];
  const toggleViewImageSlider = (selImageIndex) => {
    updateViewImageSlider({
      selImageIndex: selImageIndex,
    });
  };

  const [showComplianceUpdateLoader,setShowComplianceUpdateLoader] = useState(false);
  const [countryUpdatedFromSmartFill,setCountryUpdatedFromSmartFill] = useState(false);

  const [productNameTextAreaScrollHeight, setProductNameTextAreaScrollHeight] = useState(20);

  let taxSequence = [];
  if (props.permissions.taxZones && props.permissions.taxZones.length) {
    props.permissions.taxZones.map((ele) => {
      taxSequence.push(ele.zoneName);
    });
  }

  useEffect(() => {
    if (props.productData.isAlreadyAudited && !props.showAuditData) {
      updateTimeoutModal(true);
    }
  }, [props.productData.isAlreadyAudited]);

  useEffect(() => {
    updateType(props.variantProps.variantProductData?.length ? 1 : 0);
  },[props.variantProps.variantProductData.length])

  useEffect(() => {
    productOrService = props.selectedCategoryType;
    if (productData.categoryType) {
      productOrService = productData.categoryType.toLowerCase();
    } else if (selectTypeQuery.selectedProductType) {
      productOrService = selectTypeQuery.selectedProductType;
    } else if (selectTypeQuery.isTemp) {
      productOrService = "product";
    }
    setSelectedType(productOrService);
  }, [props.selectedCategoryType]);

  const handleResetSpecification = (dontSet) => {
    if(!dontSet){
      setBackClick(true);
    }
    props.updateEditProductDetail([{key: 'specification',value: []}])
    props.resetBrandManufactureData();
    props.setHybridData("");
    props.resetSpecificationFormData(true);
  };


  useOnScroll({
    callback : (e,scrollObj) => {
      if(scrollObj.currScroll.scrollTop){
        setScroll(true);
      }else{
        setScroll(false)
      }
    },
    element : !scrollEl ? null : scrollEl,
    deps: [scrollEl]
  })

  useEffect(() => {
    if (errors["image"] && props.variantImagesLength) {
      handleFocus(null, "image");
    }
  }, [props.variantImagesLength]);


  useEffect(() => {
		if(props.session.user.loginData && (!props.session.user.loggedUser || (props.session.user.loggedUser && allowedContractors.indexOf(props.session.user.loggedUser.subType) == -1))){
            history.push('/contractor-login/v4');
		}
  },[props.session.user.loginData]);

  useEffect(() => {
    savedUOM.current = props.unitOfMeasurement;
  }, [props.session.isAppInitialized, props.unitOfMeasurement]);
  const mounted = useRef();
  useEffect(() => {
    if (!mounted.current) {
      mounted.current = true;
    } else {
      if (moreFieldsShown) {
        window.scrollBy({
          top: moreFieldsRef.current.offsetHeight + 20,
          behavior: "smooth",
        });
      }
    }
  }, [moreFieldsShown]);

  //prefilled Data for branded Product Specs
  useEffect(() => {
    // let noSid = props.sendBMDetails.find((el) => !el.sid);
    let manufactureDetails = {};
    if (props.hybrid.length) {
      let productHeight = props.brandManufacturer.detailsSpecification.find(el => el.sid === '5724');
      let productWidth = props.brandManufacturer.detailsSpecification.find(el => el.sid === '5723');
      let productLength = props.brandManufacturer.detailsSpecification.find(el => el.sid === '11426');
      let actualProductWeight = props.brandManufacturer.detailsSpecification.find(el => el.sid === '7926');
      props.updateEditProductDetail([
        {
          key: 'productHeight',
          value: productHeight?.sdv?productHeight?.sdv:productData.productHeight
        },
        {
          key: 'productWidth',
          value: productWidth?.sdv?productWidth?.sdv:productData.productWidth
        },
        {
          key: 'productLength',
          value: productLength?.sdv?productLength?.sdv:productData.productLength
        },
        {
          key: 'actualProductWeight',
          value: actualProductWeight?.sdv?actualProductWeight?.sdv:productData.actualProductWeight
        }
    ])
      let sendBmData = [...props.sendBMDetails];
      sendBmData.map((cur) => {
        let element = props.hybrid.find((el) => (el.name == cur.name));
        let elInSpec = props.savedPuvSpecAttributes.find(
          (el) => el.s_nm == cur.name
        );
        if (element) {
          cur.values = (cur.values?.length && cur.values[0])  ? cur.values : element.values;
          cur.sid = element.sid;
          if(element.values[0])
            manufactureDetails[cur.name] = element.values[0];
        } else if (elInSpec) {
          cur.values = cur.values?.length
            ? cur.values
            : [elInSpec.userInput.value];
          cur.sid = element?.sid || elInSpec?.s_id;
          if(elInSpec.userInput.value)
            manufactureDetails[cur.name] = elInSpec.userInput.value;
        }
      });
      props.updateBrandManufactureDetails({
        ...props.brandManufacturer,
        ...manufactureDetails,
        sendDetails: [...sendBmData],
      });
    }
  }, [props.hybrid]);

  useEffect(() => {
  if(productData.compliance){
    const preDefinedData =
        props.productData.hasOwnProperty("specification") &&
        props.productData.specification?.length
          ? props.productData.specification
          : null;
    props.fetchSpecificationAttributes('',preDefinedData,{
      leafId: productData.leafId,
      bid: productData.bid,
      isTemp: true,
      isEnrich: true
    })
  }
  },[productData.compliance])


  const setFieldDetails = () => {
    let data = {};
    axios
      .get(
        "/vendorapis/products/product/getSpecInfo?spec_names=manufacturer,country_of_origin,importers_detail,importer,manufactured_details&action=getSpecInfo"
      )
      .then((res) => {
        data = res.data.data;
        if (productData.specification?.length && !selectedCountry.countryCode) {
          let countrySpec = productData.specification.find(
            (el) => el.sid == data["country_of_origin"]
          );
          let countryObj = countrySpec
            ? props.countryList.find(
                (el) => el.countryName == countrySpec.value[0]
              )
            : {};
          countryObj?.countryCode && updateSelectedCountry({ ...countryObj });
        }
        if (!productData.keywordId && productData.leafId < 0) {
          //case of Bulk Upload
          let savedSpecification = [...props.savedPuvSpecAttributes];
          productData.specification.map((cur) => {
            let elmnt = savedSpecification.find((el) => el.sid == cur.sid);
            if (elmnt) {
              elmnt.userInput.value = cur.value[0];
            }
          });
          props.updateSpecificationData({
            editablePuvSpecAttributes: [...savedSpecification],
            savedPuvSpecAttributes: [...savedSpecification],
          });
        }
        updateStatus(true);
      });
  };

  useEffect(() => {
    if (productData.compliance) {
      let {
        country_of_origin,
      } = productData.compliance;
      if (country_of_origin) {
        if (country_of_origin.split(",").length > 1) {
          country_of_origin = country_of_origin.split(",")[0];
        }
        let countryObj = props.countryList.find(
          (el) => el.countryName == country_of_origin
        );
        if(!countryObj){
          countryObj = {
            countryCode: country_of_origin?.substring(0,2)?.toLocaleUpperCase(),
            countryID: 1,
            countryName: country_of_origin,
            isdCode: 93
          }
        }
        updateSelectedCountry({ ...countryObj });
      }
        if (!props.hybrid.length && !backClick && productData.compliance) {
          axios
            .get(
              "/vendorapis/products/product/getSpecInfo?spec_names="+Object.keys(productData.compliance).toString()+"&action=getSpecInfo"
            )
            .then((res) => {
              let spec = [];
              Object.keys(productData.compliance).map(cur => {
                if(productData.compliance[cur]){
                  spec.push(res.data?.data[cur]);
                }
              });

              props.addUpdateFixedSpecs({dataToAdd: spec});
              props.setHybridData({data: productData.compliance, sidData: res.data.data});
            });
        }
    }
    if(props.productSmartFillSpec?.length && !countryUpdatedFromSmartFill){
      let prodSpecObj = {};
      props.productSmartFillSpec?.map((cur)=>{
        prodSpecObj[cur.s_nm] = cur?.userInput?.value;
      });
      let {
        country_of_origin,
      } = prodSpecObj;
      if(country_of_origin) {
        if(country_of_origin.split(',').length > 1){
          country_of_origin = country_of_origin.split(',')[0];
        }
        let countryObj = props.countryList.find(el => el.countryName == country_of_origin);
        if(!countryObj){
          countryObj = {
            countryCode: country_of_origin?.substring(0,2)?.toLocaleUpperCase(),
            countryID: 1,
            countryName: country_of_origin,
            isdCode: 93
          }
        }
        updateSelectedCountry({...countryObj})
        setCountryUpdatedFromSmartFill(true);
      }
    }
    if(!selectedCountry.countryCode && props.countryList.length && (productData.productId != 'ADD_PRODUCT' || productData.isDuplicate)){
      let countrySpec = props.editablePuvSpecAttributes.find(el => el.s_nm == 'country_of_origin');
      if(countrySpec && productData.specification?.length) {
        countrySpec = productData.specification.find(el => el.sid == countrySpec.s_id);
        let countryObj = countrySpec?props.countryList.find(el => el.countryName == countrySpec.value[0]):{};
        if(!countryObj && countrySpec?.value[0]){
          countryObj = {
            countryCode: countrySpec.value[0]?.substring(0,2)?.toLocaleUpperCase(),
            countryID: 1,
            countryName: countrySpec.value[0],
            isdCode: 93
          }
        }
        updateSelectedCountry({...countryObj})
      }
    }
    if (
      !selectedCountry.countryCode &&
      productData.productId != "ADD_PRODUCT" &&
      !productData.keywordId
    ) {
      !fieldsSet && setFieldDetails();
    }
  },[props.countryList,props.editablePuvSpecAttributes,props.productSmartFillSpec])

  useEffect(() => {
    //addBackHandler(closeCatSliderOnBack);
    if (Number(isProductOnlyProfile) == 1 && isAddProduct) {
      toggleSellOnline(true);
    }
    if (Number(props.session?.newProfile) == 0 && productData.isSellOnline && productData.productId != "ADD_PRODUCT") {
      updateIsSellOnlineProduct(true);
      updateTabs(true);
    }else if(Number(props.session?.newProfile) == 1 && !productData.isSellOnline && productData.productId != 'ADD_PRODUCT') {
      updateTabs(true);
    }

    !props.countryList.length && props.fetchCountryCode();
    if(window){
      window.appHandler = (jsonStr) => {
          try {
          const transformedJson = JSON.parse(jsonStr);
          const {eventType, redirectionurl} = transformedJson;
          if(redirectionurl){
              window.location.replace(redirectionurl);
          }else if(eventType == "deviceback"){
              if (JdLiteInterface && JdLiteInterface.verticalHandler) {
                  const exitJson ={"action":"exit"};
                  JdLiteInterface.verticalHandler(JSON.stringify(exitJson));
              }
          }
          } catch (e) {
          console.log(e)
          }
      };
      if(props.isJdSourceAndroid){
        pageLoad();
      }else if (props.isJdBusinessIOS) {
				pageLoadForIos();
			}
    }
    return () => {
      //removeBackHandler(closeCatSliderOnBack);
      if (saveButtonStatus.current != "saved") {
        if (productData.productId) {
          props.resetProductData({
            dontResetEditProduct: dontResetEditProduct.current, // in case of jd gallery,
            AddImagestoListing: false
          });
        }
      } else {
        if (props.isJdPhotoSlider && !props.directAddToProduct && !fromPhotos) {
          if (props.deviceData.isMobile) {
            setTimeout(() => {
              history.goBack();
            }, 300); // slider close timeout
          } else {
            historyHandler.closeAll();
          }
        }
      }
      scrollRef.current &&
        scrollRef.current.removeEventListener("scroll", scrollHandler);
    };
  }, []);

  let leftIconArr = [
    {
      className: "icon-hdrBackNew",
      onClick: () => {
        // props.resetProductData();
        if (productData.productId) {
          props.discardAddProductMedia();
        }
        handleResetSpecification();
        props.hideProductEditSlider();
        props.resetVariantData();
        props.deviceData.isMobile && props.setShouldRetainScroll(true);
        if((props.isJdSourceAndroid || props.isJdBusinessIOS) && fromSellerRejected){
          window.location.href = 'https://jdext.php';
        }else{
          history.goBack();
        }
      },
    },
  ];


  let drawerOptions, drawerOnClick, drawerTitle;

  type = type ? type : productData.queueType;
  leftIconArr = [];

  drawerTitle = "SKIP PRODUCT";
  drawerOptions = {
    skipFetch: {
      text: "Skip & Fetch Another Product",
      value: "skipFetch",
    },
    skipStop: {
      text: "Skip & Stop",
      value: "skipStop",
    },
  };

  const fetchResolve = (options = {}) => {
    let { url, redirectToHome } = options;
    if (url != '' && !redirectToHome) {
      if (window.top != window.self) {
        url += "&loadedInIframe=true";
      }
      window.location.href = url;
      redirect();
    } else {
      alert("No Products Found in queue");
      history.push(enrichHomePath);
    }
  };

  drawerOnClick = (e, key) => {
    skipEnrichProduct({
      productId: productData.productId,
      cb: (data) => {
        if (data.data.results.code == 0) {
          if (key.value == "skipFetch") {
            fetchEnrichUrl({
              queueType: productData.queueType,
              cb: (data) => {
                fetchResolve(data);
              },
            });
          } else if (key.value == "skipStop") {
            history.push(enrichHomePath);
          }
        }
      },
    });
    updateSkipDrawer("");
  };

  const handleFocus = (e, key) => {
    // e &&
    //   e.currentTarget &&
    //   scrollIntoView(e.currentTarget, "edit-product-form");
    const newErrors = { ...errors };
    newErrors[key] = "";
    updateError(newErrors);
  };
  const handleChange = (e, key, options = {}) => {

    let value =
      options.value ||
      (key == "description" ? e.target.innerHTML : e.currentTarget.value);
    if (otherThanEnglish.test(value)) {
      return;
    }
    switch (key) {
      case "description":
        setProductDescriptionEdited(true)
        break;
      case "actualProductWeight":
        {
          if (!actualProductWeightRegex.test(value)) {
            return;
          }
        }
        break;
      case "productLength":
        {
          if (!productDimensions.inputField.test(value)) {
            return;
          }
        }
        break;
      case "productWidth":
        {
          if (!productDimensions.inputField.test(value)) {
            return;
          }
        }
        break;
      case "productHeight":
        {
          if (!productDimensions.inputField.test(value)) {
            return;
          }
        }
        break;
    }
    setFieldValue(key, value, productData.uomType);
  };

  const setFieldValue = (key, value, uomType) => {
    props.updateEditProductDetail({
      key,
      value: value,
      uomType,
    });
  };

  const checkError = (value, key, newErrors, isError) => {
    switch (key) {
      case "productName":
        {
          value = value.trim();
          if (!value) {
            return `${"Please Enter"} ${productOrServiceLabel}`;
          }
          if (value.length < 3) {
            return `${productOrServiceLabel} ${"Should Have 3 or More Characters"}`;
          }
        }
        break;
      case "countryOfOrigin":
        {
          if (
            !selectedCountry.countryCode &&
            selectedType == "product"
          ) {
            return "Please Enter the Country Of Origin";
          }
        }
        break;
    }
    return false;
  };

  const checkErrorForManufactImport = (newErrors, isError) => {
    let errorField = "";
    props.sendBMDetails.forEach((cur) => {
      if (
        props.isBrandSpecIndex ||
        productData.compliance?.manufacturer ||
          productData.compliance?.manufactured_details ||
        isTemplate
      ) {
        if (
          showSellOnline &&
          cur.name === "brand" &&
          !cur.values[0] &&
          !(isTemplate || isBrandedProduct)
        ) {
          newErrors["brandName"] = "Please Enter Brand";
          errorField = "Please Enter Brand";
        }
        if (showSellOnline &&
          ["manufacturer", "manufactured_details"].includes(cur.name) &&
          !cur.values[0] && (props.brandManufacturer.manuFacturerMand || productData.isManufacturerMand)
        ) {
          newErrors["manufacturerDetails"] =
            "Please Enter Manufacturer Details";
          errorField = errorField
            ? errorField
            : "Please Enter Manufacturer Details";
        }
      }
      if (
        showSellOnline &&
        selectedCountry.countryCode &&
        selectedCountry.countryCode != "IN"
      ) {
          let importerArrayString = cur.values.join("");
          if (
            ["importer", "importers_detail"].includes(cur.name) &&
            !importerArrayString
          ) {
            newErrors["ImporterDetails"] = "Please Enter Importer Details";
            errorField = errorField
              ? errorField
              : "Please Enter Importer Details";
          }
      }
    });
    if (!isError && errorField) {
      dispatch(
        toastMessageActions.showMessage({
          message: errorField,
          type: "error",
          showReduxToast: true,
          duration: 5000,
        })
      );
    }
    if (errorField) {
      return true;
    } else {
      return isError;
    }
  };

  const getFormattedSpec=()=>{

    for(let i=0;i<props.editablePuvSpecAttributes?.length;i++){
      const {s_mandatory,userInput:{value}}=props.editablePuvSpecAttributes[i];
      if(Number(s_mandatory) && value.trim()==""){
        dispatch(
          toastMessageActions.showMessage({
            message: "Please Enter Mandatory Specifications",
            type: "error",
            showReduxToast: true,
            animationTime: 5000,
          })
        );
        return false;
      }
    }
    for (let i=0;i<props.savedCustomSpecAttributes?.length;i++) {
      const {key,value}=props.savedCustomSpecAttributes[i];
      if(key.value && value.value.trim()==""){
        dispatch(
          toastMessageActions.showMessage({
            message: "Please Enter Custom Specifications",
            type: "error",
            showReduxToast: true,
            animationTime: 5000,
          })
        );
        return false;
      }
    }
    return true;
  }

  const saveData = async (options = {}) => {

    dispatch(toastMessageActions.hideMessage());

    const newErrors = { ...errors };
    let isError = false;
    let selected = false;

    if (
      !props.variantImagesLength
    ) {
      props.showToastMessage({
        showToastMessage: true,
        message:
          productOrService == "product"
            ? "Please Upload Product Image"
            : "Please Upload Service Image",
        type: "error",
        cb: (status) => {
          status == 'open' && (props.deviceData.isMobile && window || document && document.querySelector('[body-scroll-lock-ignore="true"]')).scrollTo({ top: 0, behavior: "smooth" });
        }
      });
      isError = true;
      newErrors["image"] =
        productOrService == "product"
          ? "Please Upload Product Image"
          : "Please Upload Service Image";
    }
    if (isError) {
      updateError(newErrors);
      return;
    }

    let scrollToError = (status, key) => {
      const errorElement = scrollEle.current[key];
      if (status == "open" && errorElement) {
        errorElement.scrollIntoView({ behavior: "smooth", block: "center" });
      }
    };

    let labelErr = '';
    if (labelErr=='' && proofImages.length && Number(productData.lbl_img_mandatory)) {
      props.updateEditProductDetail({
        key: 'label_image',
        value: proofImages
      })
    }

    if (isError) {
      updateError(newErrors);
      return;
    }

    const specs=getFormattedSpec();
    if (specs==false) {
      return;
    }

    isError=false;
    let atLeastOneEntered = false;
    productData.referenceLinks.map((reference, index) => {
      reference.valid = (reference.link && isValidURL(reference.link));
      if (!reference.valid && reference.link) {
        newErrors[`ReferenceLink${Number(index+1)}`] = 'Please enter valid reference link';
        dispatch(
          toastMessageActions.showMessage({
            message: 'Please enter' +(index==0 ? ' atleast one ' : ' ' ) + 'valid reference link',
            type: "error",
            showReduxToast: true,
            animationTime: 5000,
          })
        );
        isError=true;
      } else {
        newErrors[`ReferenceLink${Number(index+1)}`] = '';
      }
      if (reference.link && !atLeastOneEntered) {
        atLeastOneEntered = true;
      }
    });
    if (!isError && !atLeastOneEntered) {
      newErrors[`ReferenceLink1`] = 'Please enter valid reference link';
      dispatch(
        toastMessageActions.showMessage({
          message: 'Please enter atleast one valid reference link',
          type: "error",
          showReduxToast: true,
          animationTime: 5000,
        })
      );
      isError=true;
    }
    if (isError) {
      updateError(newErrors);
      return;
    }

    if (typeof options !== "undefined" && options.fetchNextUrl) {
      updateProdLoader(true);
    } else {
      toggleBtnLoader(true);
    }
    props.saveEnrichEditPorduct(null,  (res) => {
      if (typeof options !== "undefined" && options.fetchNextUrl) {
        updateProdLoader(false);
      } else {
        toggleBtnLoader(false);
      }
      if (
        res.data &&
        res.data.code != 0 &&
        res.data.msg &&
        res.data.msg != "Data added Successfully"
      ) {
        let newErr = {};
        let msg = res.data.msg;
        if (res.data.code==1) {
          dispatch(
            toastMessageActions.showMessage({
              message: msg,
              type: "error",
              showReduxToast: true,
              duration: 5000,
              cb: (status) => scrollToError(status, "description"),
            })
          );
          updateError({
            description: msg,
          });
        } else {
          let scrollElem = "";
          dispatch(
            toastMessageActions.showMessage({
              message: msg,
              type: "error",
              showReduxToast: true,
              duration: 5000,
            })
          );
        }

        saveButtonStatus.current = null;
        return;
      }
      if (res.isSuccess) {
        if(res.data?.code){
          handleResetSpecification();
        }

        if (options.fetchNextUrl) {
          fetchEnrichUrl({
            queueType: productData.queueType,
            cb: (data) => {
              fetchResolve(data);
              saveButtonStatus.current = "saved";
              updateProdLoader(false);
            },
          });
        } else {
          saveButtonStatus.current = "saved";
          // showSuccessPage(true);
          history.push(enrichHomePath);
        }
      }
    },
      {
        savedCustomSpecAttributes: props.savedCustomSpecAttributes,
        savedPuvSpecAttributes: props.savedPuvSpecAttributes?.length ? props.savedPuvSpecAttributes : props.editablePuvSpecAttributes,
        sendBMDetails: props.sendBMDetails,
        installData: props.installData,
        contentWeightUnitSaved: props.contentWeightUnitSaved,
      }
    );
  };

  const handleKeyDownText = (e) => {
    if (otherThanEnglish.test(e.key)) {
      e.preventDefault();
    }
  };
  const handleKeyDown = (e, key) => {
    if (key == "description") {
      if (key == "description") {
        updateError({
          ...errors,
          description: "",
        });
        let targetEle = e.target;
        setTimeout(() => {
          const text = targetEle.innerText;
          const hasText = text && text.trim();
          if (hasText) {
            togglePaste(false);
          } else {
            targetEle.innerHTML = "";
            togglePaste(true);
          }
        }, 100);
      }
    }
    if (!isIPhone) {
      return;
    }
    const keycode = e.key;
    if (keycode == "Backspace") {
      return;
    }
  };

  let isMobile = props.deviceData.isMobile;

  function getFields(fieldArr, options = {}) {
    let returnFields = options.initialEmpty ? [] : [...fieldArr];
    return returnFields;
  }
  const pasteFromClipboard = () => {
    let text = "";
    getContent((result) => {
      if (result) {
        text = result.trim();
        togglePaste(false);
        let val = formatProdDesc(text);
        setFieldValue("description", val);
      }
    });
  };
  let productOrServiceLabel = "Product Name";
  if (productOrService == "product") {
    productOrServiceLabel = "Product Name";
  } else if (productOrService == "service") {
    productOrServiceLabel = "Service Name";
  }

  const smartFillUpdateProduct = () => {
    setShowComplianceUpdateLoader(true);
		dispatch(
			updateProductsWithSmartFill({
				cb: () => {
          setShowComplianceUpdateLoader(false);
					closeComplianceModal(true);
				},
				complianceSpecsFieldsArr: props.smartFillData?.complianceArr,
				catId:
					productData.leafId == 0 && productData.isTempProd
						? productData.psv_node_id
						: productData.leafId,
            brand: props.smartFillData?.brand
			})
		);
  };

  const formElements = [
    ...getFields([
      {
        label: productOrServiceLabel,
        key: "productName",
        holderClass: `${styles["product-name-field"]} ${
          props.session.isReadOnly ? "read-only-mode" : ""
        }`,
        input: {
          maxLength: 150,
          value: productData.productName || "",
          onChange: (e) => handleChange(e, "productName"),
          onFocus: (e) => handleFocus(e, "productName"),
          onKeyDown: (e) => handleKeyDownText(e),
          readOnly: true,
        },
        inputRef: scrollEle,
        checkError: (value) => checkError(value, "productName"),
        errorClass: styles["error-text"]
      },
    ]),
    {
      checkError: (value, newErrors, isError) => {
        return checkErrorForManufactImport(newErrors, isError);
      },
      manufacturer: true,
      customJSX: (
        <div className={`${styles["marginLR15"]} ${styles["out-spec"]}`}>
          <ManufacturerDetails
            errors={errors}
            updateError={updateError}
            isTemplate={productData.isTemplate}
            isReadOnly={true}
            psvNodeId={productData.psv_node_id || productData.leafId}
            allowCountryOriginChange={()=>setCountryUpdatedFromSmartFill(false)}
            isAddProduct={isAddProduct}
            nonEditable={true}
          />
        </div>
      ),
    },
    ...getFields([
      {
        label: "EAN Barcode",
        key: "barcode",
        hide: false,
        holderClass: styles['disabled'] + styles["barcode-field-holder"],
        input: {
          value: productData.barcode || "",
          onChange: (e) => handleChange(e, "barcode"),
          readOnly: true,
        },
        parentClass: styles["barcode-field"],
        errorClass: styles["error-text"],
      },
    ]),

    {
      hide: false,
      checkError: (value) => checkError(value, "countryOfOrigin"),
      key: "countryOfOrigin",
      holderClass: styles['disabled'],
      input: {
        value: selectedCountry,
        readOnly: true,
      },
      customJSX: (
        <>
          <div className={`${styles[`country-selector`]}`}>
            <div
              className={styles[`country-holder`]}
            >
              <div
                className={`${styles[`country-container`]} ${
                  !selectedCountry.countryCode
                    ? styles[`empty-country-container`]
                    : null
                }`}
              >
                {selectedCountry.countryCode ? (
                  <>
                    <label className={styles[`country-label`]}>
                      Country Of Origin
                    </label>
                    <div className={styles["country-flag"]}>
                      <span
                        className={`flag sprite ${
                          flagStyles["sprite-" + selectedCountry.countryCode]
                        }`}
                      ></span>
                    </div>
                  </>
                ) : null}
                <div
                  className={`${styles[`country-input`]} ${(productData.compliance && productData.compliance.country_of_origin && productData.compliance.country_of_origin.toLowerCase() != 'india' && !productData.compliance.importers_detail || true) ? "disabled" : ''} ${
                    errors[`countryOfOrigin`] ? "red-border" : ""
                  } ${props.deviceData.isMobile ? "mobile-country-input" : ""}`}
                >
                  {selectedCountry.countryName
                    ? selectedCountry.countryName
                    : "Country Of Origin"}
                </div>
                <div className={styles[`country-right-icon`]}>
                  <span className={"country-arrow-icon icon-Next"}></span>
                </div>
              </div>
            </div>
          </div>
        </>
      ),
    },
    {
      hide: props.isImporterPresent || !selectedCountry.countryCode || selectedCountry.countryCode == "IN",
      checkError: (value, newErrors, isError) => {
        return checkErrorForManufactImport(newErrors, isError);
      },
      manufacturer: true,
      customJSX: (
        <div className={`${styles["marginLR15"]} ${styles["out-spec"]}`}>
          <ImporterDetails errors={errors} updateError={updateError} nonEditable={true}  />
        </div>
      ),
    },
    ...getFields([
      {
        label: `Description`,
        key: "description",
        holderClass:
        styles.marginT20 +
          " " +
          styles["wyswig-div"],
        input: {
          value:
            productData.description,
          onChange: (e, options) => handleChange(e, "description", options),
          onKeyDown: (e) => handleKeyDown(e, "description"),
          readOnly: props.session.isReadOnly ? true : false,
          onPaste: (e) => {
            e.persist();
            setTimeout(() => {
              const value = formatProdDesc(
                document.querySelector(".wyswig-div [contenteditable]")
                  .innerHTML
              );
              if (value.length) {
                togglePaste(false);
              }
              handleChange(e, "description", {
                value,
              });
            }, 0);
          },
        },
        inputRef: scrollEle,
        as: "editableContent",
        hide: !productDescriptionEdited && productData.description?.length>=600,
        showRightSectionAlways: true,
        rightSection: () =>
          showPaste ? (
            <div
              className={styles["paste-option"]}
              onClick={() => pasteFromClipboard()}
            >
              Paste
            </div>
          ) : null
      },
    ]),
  ];
  const moreElements = [];

  let location = useLocation();

  let headerText = "Enrich Product";

  if (productOrService == "both") {
    headerText = "Edit Product / Service";
  } else if (productOrService == "service") {
    headerText = "Edit Service";
  }

  let noImgLabel = "Add a Product Photo";
  if (productOrService == "product") {
    noImgLabel = "Add a Product  Photo";
  } else if (productOrService == "service") {
    noImgLabel = "Add a Service Photo";
  }

  const editViewImageProps = {
    updateProductImage: props.updateProductMedia,
    deleteProductImage: props.deleteProductImage,
    deleteProductVideo: props.deleteProductVideo,
    showToastMessage: props.showToastMessage,
    showUndoToast: true,
    restoreProductData: props.restoreProductData,
    toggleLibrarySlider: props.toggleLibrarySlider,
    ignoreSave: true,
    isTemplate: false,
    canUploadImage: true,
    isReadOnly: false,
    uploadSingleImage: false,
    productId: productData.productId,
    showDots: false,
    isAddEditPage: true,
    videoUrlIds:props.productData.videoUrlIds,
    noImgLabel: noImgLabel,
    onViewImageClick:toggleViewImageSlider,
    hideSaveButton: false,
    errorMessage: errors["image"]
      ? productOrService == "product"
        ? "Please Upload Product Image"
        : "Please Upload Service Image"
      : "",
    isMobile: props.deviceData.isMobile,
    categoryType: !isAddProduct ? productData.categoryType : null,
    isTempProd: false,
    dontShowPrimaryTag: false,
    imageUrlArr: imageArray,
    imgUploadUrl: 'isEnrich/marketplace/products/ajax/uploadProductImageForB2B.service?supplierid=1728767',
    isEnrich: true
  };

  const readOnlyViewImageProps = {
    imageUrlArr: mediaUrlArr,
    hideSaveButton: true,
    isReadOnly: true,
    isReadOnlyImageSlider: true,
    canUploadImage: true,
  };
  let saveButtonText = "Save";
  if (productData.reviewStatus == "APPROVAL_PENDING" && isOwner) {
    saveButtonText = "Save and Approve Product";
  } else if (isOwner && !productData.ownerEdit && productData.isObjectionable) {
    saveButtonText = "Save & Request to Take Live";
  }
  const scrollHandler = (e) => {
    setScroll(e.target.scrollTop);
  };

  const handleComplianceHistory = () => {
    // history.go(complianceModalShown ? -3 : -2);
    if(complianceModalShown){
        history.go(-3);
    }else{
        history.go(-2);
    }
  }

  const showProductUpdatedStatus = () => {
    handleResetSpecification();
    dispatch(
      toastMessageActions.showMessage({
        message: `Product ${isAddProduct ? "Added" : "Updated"} Successfully`,
        showReduxToast: true,
        duration: 5000,
      })
    );
    if (props.deviceData.isMobile) {
      setRouteChangeMessage({
        message: `Product ${isAddProduct ? "Added" : "Updated"} Successfully`,
      });
    }
    if(props.listingProdData.prodCount <= 1 && props.tabKey != 'auditPending'){
      props.setTabStatus({ tabKey: undefined }); //#329519
    }else{
      props.setTabStatus({ tabKey: props.tabKey }); //#329519
    }
    saveButtonStatus.current = "saved";
    if (productData.isDuplicate) {
      history.replace("/products");
      if (!props.deviceData.isMobile) {
        history.goBack();
        if (props.isSearchSliderOpen) {
          history.goBack();
        }
      }
    } else {
      saveButtonStatus.current == "saved" && props.resetProductData({});
    }
  };

  const closeComplianceModal = (status) =>{
    updateShowComplianceModal(false);
    setComplianceModalShown(true);
    if(docReqModal.docs?.length){
      let reqModalData = {...docReqModal};
      reqModalData.show = true;
      toggledocReqModal(reqModalData);
    }else{
      showProductUpdatedStatus(status);
    }
  }



  const EditProduct = (
    <>
      {
        <>
          {(showBtnLoader || enrichProdLoader) &&
            <div className="blur-loader"></div>
          }
          <div
            ref={scrollRef}
            onScroll={(e) => {
              scrollHandler(e);
            }}
            className={
              enrichStyles["enrich-edit-product"] +
              " " +
              styles["add-edit-product"] +
              (isIPhone ? " " + styles["jd-iphone"] : "") +
              " " +
              (type ? "product-type" : "") +
              (isMobile ? ` ${styles["isMob"]}` : " " + styles["isWeb"])
            }
          >
            { props.deviceData.isMobile ? (
              <div
              className={
                styles["edit-product-header"] +
                (isScrolled ? " scrolled" : "") +
                (props.session.isReadOnly
                  ? " " + styles["readonly-header"]
                  : "")
              }
            >
              <SliderHeader
                className={styles["add-edit-header"]}
                heading={headerText}
                leftIcons={isMobile ? leftIconArr : []}
                variant="secondary"
                headingClass={styles["header-title"]}
              />
            </div>
            ) : null }
            <CSSTransition>
              <div
                className={
                  styles["edit-product-form"] +
                  " " +
                  enrichStyles["enrich-edit-form"]  +
                  " " +
                  (props.session.isReadOnly ? styles["readonly-edit-form"] : "")
                }
              >
              <>
                <div className={styles["marginLR15"]}>
                  <div className={styles["user-details-holder"]}>
                      <ProductBankIdCopy showToastMessage={props.showToastMessage} productBankId = {productData.productId}  copyLabel="Product Bank ID" isMobile={isMobile} styles = {enrichStyles} />
                  </div>
                  {!props.variantProps?.variantProductData?.length ? (
                    <ViewImage showSortImage key="image-slider" {...editViewImageProps} />
                  ) : (
                    <div style={{ marginTop: "20px" }} />
                  )}
                  {Number(productData.lbl_img_mandatory) ?
                    <PackagingLabel
                      proofImages={proofImages}
                      labelFront={labelFront}
                      setFrontImage={setFrontImage}
                      errors={errors}
                      updateError={updateError}
                      setProofImagesList={setProofImagesList}
                    />
                    :
                    <ImageZoom
                      imageHolderClass={`proof-images-add-edit ${labelFront[0]?.url?'front':''} ${proofImages[0]?.url?'back':''}`} updateList={list => {
                        setProofImagesList(list)
                      }}
                      title={"Proof of Product Packaging Label"}
                      images={[...labelFront,...proofImages].map((cur,index) => {
                        return {
                          ...cur,
                          fileId: index
                        }
                      })}
                      isAuditor
                  />
                    }
                </div>

                {<FormElement
                  formElements={formElements}
                  errors={errors}
                />}
                {
                  <div ref={moreFieldsRef}>
                    <ProductSpecification
                      showSellOnline={showSellOnline}
                      isAddProduct={isAddProduct}
                      showInstall={productData.showInstall}
                    />
                  </div>
                }
                {productData.referenceLinks ?
                <>
                <div className={`${enrichStyles['reference-id']} ${styles['input-holder']} ${styles['variant-option']}`}>
                  {productData.referenceLinks.map((reference, index) => {
                    let wrapper=(elem)=><>{elem}</>
                    if(index && index==productData.referenceLinks.length-1){
                      wrapper=(elem)=><div className={enrichStyles["referenceLink_with_delete"]}>
                        {elem}
                        {productData.referenceLinks.length > 1 && <i onClick={()=> {productData.referenceLinks.pop(); setFieldValue('referenceLinks', [...productData.referenceLinks])}} className={`icon-trash ${enrichStyles['delete-option']} ${false ? enrichStyles['greyed-out'] : ''}`} />}
                      </div>
                    }

                    return wrapper(<InputWithMovingLabel
                      label={`Reference Link ${Number(index+1) || ''}`}
                      key={`ReferenceLink${Number(index+1)}`}
                      errorMessage={errors[`ReferenceLink${Number(index+1)}`]}
                      input={{
                          value: reference.link,
                          onChange: e => {
                            const { target:{ value } } = e;
                            const referenceValue = [...productData.referenceLinks];
                            referenceValue[index] = {link: value, valid: true};
                            setFieldValue('referenceLinks', referenceValue);
                          },
                          onBlur: e => {
                            const { target:{ value } } = e;
                            const referenceValue = [...productData.referenceLinks];
                            referenceValue[index] = {link: value, valid: (value ? isValidURL(value) : true)};
                            setFieldValue('referenceLinks', referenceValue);
                            if (referenceValue[index].valid) {
                              errors[`ReferenceLink${Number(index+1)}`] = '';
                            } else {
                              errors[`ReferenceLink${Number(index+1)}`] = 'Please enter valid reference link';
                            }
                            updateError(...errors);
                          }
                      }}
                  />)
                  })}
                </div>
                {
                  productData.referenceLinks.length < 3 ? (<div className={enrichStyles['add-another']} style={{ cursor: 'pointer' }} onClick={() => setFieldValue('referenceLinks', [...productData.referenceLinks, {link: '', valid: true}])}><i className="icon-plus" /> <span>Add Another Reference Link</span></div>) : null
                }
                </>
                : null}
                </>
                {<>
                    <div
                      className={
                        styles["marginLR15"] +
                        " " +
                        styles["marginB16"] +
                        " " +
                        styles["audi-save-btn-holder"]
                      }
                    >
                      <Button
                        size="lg"
                        block
                        clickHandler={() => {
                          saveData({
                            fetchNextUrl: true,
                          })
                        }}
                        showLoader={enrichProdLoader}
                        className={"auditor-btn"}
                      >
                        Save and Fetch Another Product
                      </Button>
                      <div className={styles["partial-btns"]}>
                        <Button
                          size="lg"
                          variant="default"
                          className={styles["first-btn"]}
                          clickHandler={() => {
                            updateSkipDrawer("skipProduct");
                          }}
                        >
                          Skip  Product
                        </Button>
                        <Button
                          size="lg"
                          variant="default"
                          className={styles["second-btn"]}
                          clickHandler={saveData}
                          showLoader={showBtnLoader}
                        >
                          Save & Stop
                        </Button>
                      </div>
                    </div>
                  </>
                  }
                {skipDrawer && (
                  <SwipeableDrawer
                    onHidden={() => {
                      updateSkipDrawer(false);
                    }}
                    title={drawerTitle}
                    drawerOptions={drawerOptions}
                    onClick={drawerOnClick}
                    className={"fetch-swipe-drawer"}
                  />
                )}
              </div>
            </CSSTransition>
            {isMobile ? (
              <>
                <UploadOptions
                  onUploadOptionClick={(value) => {
                    if (value === "jdGallery") {
                      dontResetEditProduct.current = true;
                    }
                  }}
                  categoryType={!isAddProduct ? productData.categoryType : null}
                  isEnrich
                  imgUploadUrl="isEnrich/marketplace/products/ajax/uploadProductImageForB2B.service?supplierId=1728767"
                />
                <LinkUploadSlider />
                <CopyImagesSlider listClass={"list-aligned-top"} />
              </>
            ) : null}
          </div>
          {props.showLibrarySlider && props.deviceData.isMobile && (
            <VideoListing />
          )}
          {
            imageSliderVisible && (
              <ViewImageSlider
                className={"read-only-image-slider"}
                key="read-only-image-slider"
                session={props.session}
                isBrandedProduct={isBrandedProduct}
                onHidden={() => updateViewImageSlider(null)}
                {...imageSliderVisible}
                {...(props.session.isReadOnly || isBrandedProduct
                  ? readOnlyViewImageProps
                  : editViewImageProps)}
              />
            )}
        </>
      }
    </>
  );
  if (props.deviceData.isMobile) {
    return (
		<>
			{EditProduct}
		</>
	);
  } else {
    return (
      <>
        <SliderWrapper
          slider={{
            slideDirection: "right",
            // showOverlay: true
          }}
          enableHeader
          header={{
            className: `${styles["add-edit-header"]} ${styles["add-edit-header-no-border"]} ${isScrolled>10?styles["add-edit-header-scrolled"]:""}`,
            heading: headerText,
            leftIcons: isMobile ? leftIconArr : [],
            rightIcons: [],
            variant:"secondary",
            headingClass: styles["header-title"],
          }}
          onHidden={() => {
            props.hideProductEditSlider();
            props.discardAddProductMedia();
            handleResetSpecification();
            props.resetVariantData();
          }}
          onScroll={(e)=>scrollHandler(e)}
        >
          {EditProduct}
        </SliderWrapper>
        {showComplianceModal ? (
            <ComplianceFieldModal
              toggleModal={() => closeComplianceModal(true)}
              deviceData={props.deviceData}
              smartFillUpdateProduct={smartFillUpdateProduct}
              showLoader={showComplianceUpdateLoader}
            />
          ) : null}
      </>
    );
  }
};

const mapStateToProps = (state) => {
  let hideLBH = false;
  let hideWeight = false;
  const editProduct = state.products.editProduct || {};
  let isBrandSpecIndex = "", isImporterPresent = true;
  let productId = "";
  const uom = state.uom;
  if(state.brandManufacturer?.detailsSpecification?.length){
    let length = state.brandManufacturer.detailsSpecification.find(el => el.sid === "11426");
    let height = state.brandManufacturer.detailsSpecification.find(el => el.sid === "5724");
    let width = state.brandManufacturer.detailsSpecification.find(el => el.sid === "5723");
    let weight = state.brandManufacturer.detailsSpecification.find(el => el.sid === "7926");
    hideLBH = length && width && height;
    hideWeight = weight ? true: false;
  }
  let unitOfMeasurement = {},
    unitPerPiece = {},
    oldUnitOfMeasurement = {};
  if (editProduct) {
    productId = editProduct.productId;
    if (editProduct.unitOfMeasurement) {
      unitOfMeasurement = getMatchedUOM(
        uom.productUOM,
        editProduct.unitOfMeasurement
      );
    }
    if (!Object.keys(unitOfMeasurement).length) {
      unitOfMeasurement.displayVal = editProduct.unitOfMeasurement;
    }
    editProduct.uomType =
      state.products.uomType || unitOfMeasurement.uomType || "";
    if (editProduct.unitPerPiece) {
      unitPerPiece = getMatchedUOM(uom.netweightUOM, editProduct.unitPerPiece);
      unitPerPiece = unitPerPiece.displayVal
        ? unitPerPiece
        : { displayVal: editProduct.unitPerPiece };
    }
  }

  const imageUrlArr = productId
    ? state.products.editProduct.imageUrlArr
    : [];
  if(editProduct && productId != 'ADD_PRODUCT'){
    editProduct.imageUrlArr = imageUrlArr;
  }
  const variantImagesLength = imageUrlArr?.length || 0 ;
  let productData = state.products.allProducts[productId] || {};
  if (Boolean(editProduct && productId != 'ADD_PRODUCT' && editProduct.videoUrlIds)) {
    editProduct.videoUrlIds = editProduct.videoUrlIds;
    editProduct.videoUrlArr = editProduct?.videoUrlIds.map((curId) => {
      return state.videoLibrary.videos[curId];
    });
  } else {
    editProduct.videoUrlArr = [];
  }
  editProduct.queueType = state.products.queueType;
  let editablePuvSpecAttributes =
    state.productSpecification.editablePuvSpecAttributes;
  if (
     editProduct.isTemplate
  ) {
    if (editablePuvSpecAttributes.length) {
      for (var index = 0; index < editablePuvSpecAttributes.length; index++) {
        if (editablePuvSpecAttributes[index].s_nm == "brand") {
          isBrandSpecIndex = true;
          break;
        }
      }
    } else if (editProduct?.specification?.length) {
      isBrandSpecIndex = true;
    }
  }
  if (editProduct.compliance) {
    if (
      editProduct.compliance.manufacturer &&
      editProduct.compliance.manufactured_details
    ) {
      isBrandSpecIndex = false;
    } else {
      isBrandSpecIndex = true;
    }
    if (
      editProduct.compliance.importer &&
      editProduct.compliance.importers_detail
    ) {
      isImporterPresent = false;
    } else {
      isImporterPresent = true;
    }
  }
  return {
	  uom:state.uom,
    productData: editProduct,
    deviceData: state.deviceData,
    unitOfMeasurement,
    oldUnitOfMeasurement,
    unitPerPiece,
    variantImagesLength,
    showLibrarySlider: state.videoLibrary.showLibrarySlider,
    session: state.session,
    auditData: state.products.auditData,
    showAuditData: editProduct.showAuditData,
    tabKey: state.products.tabKey,
    listingProdData: state.products.listing,
    userData: state.session.user.loginData,
    timestampAudit: editProduct.timestampAudit,
    countPerDocId: editProduct.countPerDocId,
    isJdPhotoSlider: state.photosGallery.isJdPhotoSlider,
    directAddToProduct: !!state.photosGallery?.jdPhotosData?.variantId,
    isSearchSliderOpen: state.products.isSearchSliderOpen,
    countryList: state.products.countryList,
    isJdSourceIOS: state.session.isJdSourceIOS,
    selectedCategoryType: state.products.selectedCategoryType,
    savedCustomSpecAttributes:
      state.productSpecification.savedCustomSpecAttributes,
    savedPuvSpecAttributes: state.productSpecification.savedPuvSpecAttributes,
    permissions: state.permissions,
    user: state.session.user,
    productSpecification: state.productSpecification,
    isBrandSpecIndex,
    isImporterPresent,
    brandManufacturer: state.brandManufacturer,
    sendBMDetails: state.brandManufacturer.sendDetails,
    installData: state.brandManufacturer.installData,
    specification: editProduct.specification,
    viaSuggested: state.products.viaSuggested,
    viaSearchSuggested: state.products.viaSearch,
    editablePuvSpecAttributes,
    hybrid: state.hybrid.hybridToSend,
    variantProps: state.variants,
    variantSpec: state.variants.variantSpec,
    hasVariantSpec: state.variants.variantSpec.length,
    smartFillData: state.products.smartFillData,
    auditorBrandedLog: state.products.auditorBrandedLog,
    contentWeightUnitSaved: state.brandManufacturer.contentWeightUnitSaved,
    productSmartFillSpec: state.productSpecification.productSmartFillSpec,
    docIdSearch: state.products.docIdSearch,
    fromSellerDashboard: state.products.fromSellerDashboard,
    bizSuggestion: [],
    isSourceJustdial: state.session.isJdSourceAndroid || state.session.isJdSourceIOS,
    isJdBusinessIOS: state.session.isJdBusinessIOS,
    isJdSourceAndroid: state.session.isJdSourceAndroid,
    hideLBH,
    hideWeight
  };
};

export default connect(mapStateToProps, {
  updateEditProductDetail,
  resetSpecErrors,
  showToastMessage: toastMessageActions.showMessage,
  saveEnrichEditPorduct,
  resetProductData,
  hideProductEditSlider,
  getBizList,
  updateBizList,
  updateProductMedia,
  deleteProductImage,
  deleteProductVideo,
  toggleBiz,
  toggleLibrarySlider,
  discardAddProductMedia,
  updateProductStatus,
  getListingData,
  setAuditObject,
  restoreProductData,
  setTabStatus,
  fetchCountryCode,
  showItemSearchSlider,
  fetchSpecificationAttributes,
  resetSpecificationFormData,
  updateBrandManufactureDetails,
  setBrandSuggestion,
  updateSpecificationData,
  resetBrandManufactureData,
  setHybridData,
  resetVariantData,
  validateVariants,
  setVariantProductData,
  getAuditProductUpdateLog,
  addRemoveSpecVariant,
  setShouldRetainScroll,
  addUpdateFixedSpecs,
  setVariantData
})(EnrichEditProduct);
